import pkg from '../package.json';

export const APP_VERSION = pkg.version.split('.').slice(0, 2).join('.');
